import { useParams } from "react-router-dom";
import packageJson from "../../../package.json";
import { useLanguageContext, useWebGalleryStore } from "../../hooks";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";
import { IWebGalleryUrlParams } from "../App";
import { Filmstrip } from "../partials/Filmstrip";

type GalleryFooterProps = {
  disableThumbnails?: boolean;
};

export const GalleryFooter = ({ disableThumbnails }: GalleryFooterProps) => {
  const store = useWebGalleryStore();
  const { assetId } = useParams<IWebGalleryUrlParams>();
  if (assetId && store.selectedAsset) {
    return (
      <>
        <Filmstrip
          galleryAssets={store.assets}
          initialIndex={store.selectedAssetIndex}
          selectedAsset={store.selectedAsset}
          getNextAsset={store.getNextAsset}
          getPreviousAsset={store.getPreviousAsset}
          hasPreviousAsset={store.hasPreviousAsset}
          hasNextAsset={store.hasNextAsset}
          disableThumbnails={disableThumbnails}
        />
        <GalleryFooterDefault />
      </>
    );
  }
  return <GalleryFooterDefault />;
};

const GalleryFooterDefault = () => {
  const { lng } = useLanguageContext();
  const { t } = useCustomTranslation("Footer");
  const year = new Date().getFullYear();
  const versionNumber = process.env.REACT_APP_VERSION
    ? process.env.REACT_APP_VERSION
    : packageJson.version;
  const locationOrigin = process.env.REACT_APP_DEV
    ? "http://localhost:1337"
    : document.location.origin;
  return (
    <div className="gallery-footer">
      <div className="gallery-footer__content footer--left">
        <span>&#169; {year} MediaValet Inc. &nbsp;</span>
        <a
          className="footer-link"
          href={`${locationOrigin}/terms/view/${lng}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("TermsCond")}
        </a>
        <span>&nbsp; | &nbsp;</span>
        <a
          className="footer-link"
          href={`${locationOrigin}/privacy-policy/view/${lng}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("PrivacyPol")}
        </a>
      </div>
      <div className="gallery-footer__content footer--center">
        <a
          className="footer-link"
          href={"https://mediavalet.com/what-is-dam-lightbox/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("PowByMedVal")}
        </a>
      </div>
      <div className="gallery-footer__content footer--right">
        {`${t("Release")}: ${versionNumber}`}
      </div>
    </div>
  );
};
